import { Component, OnInit, Input, Inject, LOCALE_ID } from '@angular/core';

/**
 * Component per mostrar el marcador d'un parking del tipus Trams de perill
 */ 
@Component({
  selector: 'app-tram-perill',
  templateUrl: './tram-perill.component.html',
  styleUrls: ['./tram-perill.component.css']
})
export class TramPerillComponent implements OnInit {

  /**
   * Feature que conté les propietats per crear el marcador
   */
  @Input() feature;

  /**
   * Capa a la qual pertany el marcador
   */
  @Input() layer;

  /**
   * Textos indicant els invells de perill
   */
  TEXT_PERILL: string[] = ["Muy bajo","Bajo","Medio","Elevado","Muy elevado"];

  /**
   * Conté les propietats del feature
   */
  properties;

  /**
   * Url de la icona a mostrar
   */
  iconUrl: string;

  /**
   * Carretera on s'ha produt la incidència
   */
  road: string;

  /**
   * Punt kilomètric inicial de la incidència 
   */
  start_kp: string;

  /**
   * Punt kilomètric final de la incidència 
   */
  end_kp: string;

  /**
   * Font d'informació 
   */
  source: string;

  /**
   * Nivell de perill de la incidència
   */
  levelOfService: string;

  /**
   * Descripció del nivell de perill
   */
  levelOfServiceText: string; 

  /**
   * Constructor del component
   * @param {string} localeId indica l'idioma actual de la pàgina 
   */
  constructor(@Inject(LOCALE_ID) protected localeId: string) { }

  /**
   * Retorna el text per compartir el marcador
   * @returns {string} text per compartir el marcador
   */
  generateShareText(): string{
    var titol;
    if(this.localeId === 'es') titol = "Tramo%20con%20nivel%20de%20riesgo%20" + this.levelOfServiceText + "%20en%20"
    else titol = titol = "Tram%20amb%20nivell%20de%20risc%20" + this.levelOfServiceText +"a%20";

    return titol + this.road + "%20Km%20" + this.start_kp + "%20-%20" + this.end_kp + ".%20#infotransit" ;
  }

  /**
   * Retorna la url que mostra el mapa centrat en el marcador
   * @returns {string} url que mostra el mapa centrat en el marcador
   */
  generateShareUrl(): string{
    var baseUrl = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + '/infotransit';
    var params = "/%3Flat%3D" + this.feature.geometry.coordinates[1]
                  + "%26lng%3D" + this.feature.geometry.coordinates[0]
                  + "%26zoom%3D" + "15"
                  + "%26layers%3D" + this.layer;
    return baseUrl + params;
  }

  /**
   * inicialitza les propietats del component
   */
  ngOnInit() {

    this.properties = this.feature.properties;
    this.road = this.properties.road;
    this.start_kp = this.properties.start_kp;
    this.end_kp = this.properties.end_kp;
    this.levelOfService = this.properties.levelOfService;
    this.levelOfServiceText = this.TEXT_PERILL[parseInt(this.levelOfService)-1]
    this.iconUrl = this.getUrl();
    this.source = this.properties.source;

  }

  /**
   * Retorna la URL de la icona del marcador depenent de a quina capa pertany
   * @returns {string} URL de la icona del marcador depenent de a quina capa pertany
   */
  getUrl(){
    var url: string;
    url = 'assets/img/eurorap' + this.levelOfService + '.svg';
    return url;

  }

}
